import { Sun, Moon } from "lucide-react";
import { useTheme } from "../../theme/ThemeContext";
import { useLang } from "../../i18n/LanguageContext";

export const ThemeToggle = ({ testid = "theme-toggle", className = "" }) => {
  const { theme, toggle } = useTheme();
  const { lang } = useLang();
  const isDark = theme === "dark";
  const label = isDark
    ? lang === "en" ? "Switch to light mode" : "Cambiar a modo claro"
    : lang === "en" ? "Switch to dark mode" : "Cambiar a modo oscuro";
  return (
    <button
      data-testid={testid}
      onClick={toggle}
      aria-label={label}
      title={label}
      className={`p-2 min-w-[36px] min-h-[36px] inline-flex items-center justify-center text-onix-silver hover:text-onix-blue transition-colors ${className}`}
    >
      {isDark ? <Sun size={16} aria-hidden="true" /> : <Moon size={16} aria-hidden="true" />}
    </button>
  );
};
